export var SelectionSettlementStatus;
(function (SelectionSettlementStatus) {
    SelectionSettlementStatus["WonDeadHeat"] = "WonDeadHeat";
    SelectionSettlementStatus["PlacedDeadHeat"] = "PlacedDeadHeat";
})(SelectionSettlementStatus || (SelectionSettlementStatus = {}));
//# sourceMappingURL=SelectionSettlementStatus.js.map